import { render, staticRenderFns } from "./ConversationInfo.vue?vue&type=template&id=57576d2e&scoped=true&"
import script from "./ConversationInfo.vue?vue&type=script&lang=js&"
export * from "./ConversationInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConversationInfo.vue?vue&type=style&index=0&id=57576d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57576d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57576d2e')) {
      api.createRecord('57576d2e', component.options)
    } else {
      api.reload('57576d2e', component.options)
    }
    module.hot.accept("./ConversationInfo.vue?vue&type=template&id=57576d2e&scoped=true&", function () {
      api.rerender('57576d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/ConversationInfo.vue"
export default component.exports